import store from '@/store'
import router from './'
import { NavigationGuard, Route } from 'vue-router'
import eventTracker from '@/utils/eventTracker'

const beforeEachGuard: NavigationGuard = async (to, from, next) => {
  if (to.name === 'Index') {
    const credentials = store.getters['user/byKey']('credentials')
    if (credentials) {
      try {
        await store.dispatch('user/Login')
      }
      catch {
        store.dispatch('user/SetCredentials', null)
        return next()
      }
    }
    const token = store.getters['user/byKey']('access_token')
    if (token) {
      try {
        next({ name: 'Track' })
      }
      catch {
        next()
      }
      return
    }
    next()
  }
  else if (to.matched.some(record => record.meta.requiresAuth)) {
    const userId = store.getters['user/byKey']('userId')
    const token = store.getters['user/byKey']('access_token')
    const legalOrNext = () => {
      const acceptedAgreements = store.getters['user/byKey']('acceptedAgreements')
      if (/^Onboarding/.test(to.name as string)) {
        next()
      }
      else if (!acceptedAgreements.includes('tos')) {
        next({
          name: 'Onboarding:Slides'
        })
      }
      else if (!acceptedAgreements.includes('privacy')) {
        next({
          name: 'Onboarding:Agreements',
          query: { from: 'privacy' }
        })
      }
      else {
        next()
      }
    }
    if (userId) {
      store.dispatch('app/SetLastRoute', from)
      // presence of 'userId' implies presence of 'acceptedAgreements'
      legalOrNext()
    }
    else {
      if (token) {
        try {
          await store.dispatch('user/GetInfo')
          store.dispatch('app/SetLastRoute', from)
          legalOrNext()
        }
        catch {
          next({ name: 'Index' })
        }
      }
      else {
        next({ name: 'Index' })
      }
    }
  }
  else {
    next()
  }
}

const afterEachGuard = (to: Route) => {
  eventTracker.page(to.name || to.path)
}

router.beforeEach(beforeEachGuard)

router.afterEach(afterEachGuard)
